import React, { useState } from 'react';
import PropTypes from 'prop-types';
import generateCirurgiaPDF from '../../components/forms/generateCirurgiaPDF';
import Button from '../../components/common/Button'; // Importe seu botão genérico

const PedidoCirurgiaForm = ({ nomePaciente, clinica, onSubmit }) => {
  // Add 'clinica' to the props validation
  PedidoCirurgiaForm.propTypes = {
    nomePaciente: PropTypes.string.isRequired,
    clinica: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };
  const [diagnostico, setDiagnostico] = useState('');
  const [indicacaoCirurgia, setIndicacaoCirurgia] = useState('');
  const [tipoCirurgia, setTipoCirurgia] = useState('');
  const [dataCirurgia] = useState('');
  const [observacoes, setObservacoes] = useState('');
  const [localCirurgia, setLocalCirurgia] = useState('');
  const [anestesista, setAnestesista] = useState('');
  const [equipamentoNecessario, setEquipamentoNecessario] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const pedidoCirurgia = {
      nomePaciente,
      clinica,
      diagnostico,
      indicacaoCirurgia,
      tipoCirurgia,
      dataCirurgia,
      observacoes,
      localCirurgia,
      anestesista,
      equipamentoNecessario,
    };

    onSubmit(pedidoCirurgia);
  };

  const handleDownloadPDF = () => {
    const pedidoCirurgia = {
      nomePaciente,
      clinica,
      diagnostico,
      indicacaoCirurgia,
      tipoCirurgia,
      dataCirurgia,
      observacoes,
      localCirurgia,
      anestesista,
      equipamentoNecessario,
    };

    generateCirurgiaPDF(pedidoCirurgia);
  };

  return (
    <div>
      <h2 className="font-bold mb-4">Pedido de Cirurgia</h2>
      <form
        onSubmit={handleSubmit}
        className="space-y-6 bg-white p-6 shadow-lg rounded-lg"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="nomePaciente"
              className="block text-sm font-medium text-gray-700"
            >
              Nome do Paciente:
            </label>
            <input
              type="text"
              id="nomePaciente"
              name="nomePaciente"
              placeholder="Nome Completo do Paciente"
              value={nomePaciente}
              onChange={(e) => setDiagnostico(e.target.value)}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-teal-600 focus:border-teal-600"
            />
          </div>
          <div>
            <label
              htmlFor="planoSaude"
              className="block text-sm font-medium text-gray-700"
            >
              Plano de Saúde:
            </label>
            <input
              type="text"
              id="planoSaude"
              name="planoSaude"
              placeholder="Digite o Plano de Saúde do Paciente"
              value={diagnostico}
              onChange={(e) => setDiagnostico(e.target.value)}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-teal-600 focus:border-teal-600"
            />
          </div>

          <div>
            <label
              htmlFor="indicacaoCirurgia"
              className="block text-sm font-medium text-gray-700"
            >
              Indicação Cirúrgica:
            </label>
            <input
              type="text"
              id="indicacaoCirurgia"
              name="indicacaoCirurgia"
              placeholder="Indicação para a cirurgia"
              value={indicacaoCirurgia}
              onChange={(e) => setIndicacaoCirurgia(e.target.value)}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-teal-600 focus:border-teal-600"
            />
          </div>
          <div>
            <label
              htmlFor="procedimento"
              className="block text-sm font-medium text-gray-700"
            >
              Procedimento:
            </label>
            <input
              type="text"
              id="procedimento"
              name="procedimento"
              placeholder="Procedimento Cirúrgico"
              value={tipoCirurgia}
              onChange={(e) => setTipoCirurgia(e.target.value)}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-teal-600 focus:border-teal-600"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="cid"
              className="block text-sm font-medium text-gray-700"
            >
              CID:
            </label>
            <input
              type="text"
              id="cid"
              name="cid"
              placeholder="Classificação Internacional de Doenças"
              value={tipoCirurgia}
              onChange={(e) => setTipoCirurgia(e.target.value)}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-teal-600 focus:border-teal-600"
            />
          </div>
          <div>
            <label
              htmlFor="localCirurgia"
              className="block text-sm font-medium text-gray-700"
            >
              Local da Cirurgia:
            </label>
            <input
              type="text"
              id="localCirurgia"
              name="localCirurgia"
              placeholder="Hospital ou clínica onde será realizada a cirurgia"
              value={localCirurgia}
              onChange={(e) => setLocalCirurgia(e.target.value)}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-teal-600 focus:border-teal-600"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4">
          <div>
            <label
              htmlFor="anestesista"
              className="block text-sm font-medium text-gray-700"
            >
              Anestesista:
            </label>
            <input
              type="text"
              id="anestesista"
              name="anestesista"
              placeholder="Nome do anestesista responsável"
              value={anestesista}
              onChange={(e) => setAnestesista(e.target.value)}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-teal-600 focus:border-teal-600"
            />
          </div>
        </div>

        <div>
          <label
            htmlFor="equipamentoNecessario"
            className="block text-sm font-medium text-gray-700"
          >
            OPME:
          </label>
          <textarea
            id="equipamentoNecessario"
            name="equipamentoNecessario"
            placeholder="Detalhe o equipamento necessário para a cirurgia"
            value={equipamentoNecessario}
            onChange={(e) => setEquipamentoNecessario(e.target.value)}
            required
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-teal-600 focus:border-teal-600"
          />
        </div>

        <div>
          <label
            htmlFor="observacoes"
            className="block text-sm font-medium text-gray-700"
          >
            Observações:
          </label>
          <textarea
            id="observacoes"
            name="observacoes"
            placeholder="Observações adicionais"
            value={observacoes}
            onChange={(e) => setObservacoes(e.target.value)}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-teal-600 focus:border-teal-600"
          />
        </div>

        {/* Botões genéricos para Submissão e Download PDF */}
        <div className="flex justify-between">
          {/* Botão genérico para gerar PDF */}
          <Button
            type="button"
            label="Gerar Pedido de Cirurgia"
            onClick={handleDownloadPDF}
            className="bg-blue-600 text-white font-bold py-2 px-4 rounded hover:bg-blue-700 transition duration-200"
          />
        </div>
      </form>
    </div>
  );
};

export default PedidoCirurgiaForm;
